export default {
  props: {
    width: {
      type: String,
      default: '14px',
    },
    height: {
      type: String,
      default: '14px',
    },
    color: {
      type: String,
      default: '#000',
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/mixin-icons.js